import FieldCommentWrapper from 'common/components/FieldCommentWrapper';
import React from 'react';

export const wrapWithCommentingWrapper = (
  component,
  fieldKey,
  isCommentingAllowed = false,
  className
) => {
  if (!isCommentingAllowed) return component;

  return (
    <FieldCommentWrapper fieldKey={fieldKey} className={className}>
      {component}
    </FieldCommentWrapper>
  );
};
